import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { formatCurrency } from '../../../utils/formatters';
import { CommissionTier } from '../../../types/commissionTier';

interface Props {
  basePrice: number;
  activeTier?: CommissionTier | null;
}

export const PropertySalePriceCard: React.FC<Props> = ({ basePrice, activeTier }) => {
  const displayPrice = activeTier?.precio ?? basePrice;
  const isInitial = !activeTier || activeTier.es_inicial || activeTier.precio === basePrice;
  const hasTierScenario = activeTier && !isInitial;

  return (
    <motion.div
      layout
      className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100 transform hover:scale-[1.01] transition-all relative overflow-hidden"
    >
      <div className="flex items-center justify-between mb-1.5">
        <p className="text-[11px] sm:text-xs font-black uppercase tracking-[0.22em] text-slate-400 block">
          Precio de Venta
        </p>
        {activeTier && (
          <span
            className={`inline-flex items-center gap-1 text-[10px] font-black px-2 py-0.5 rounded-full border ${
              isInitial
                ? 'text-indigo-700 bg-indigo-50 border-indigo-200/60'
                : 'text-sky-700 bg-sky-50 border-sky-200/60'
            }`}
          >
            <span>
              {isInitial ? 'Inicial: ' : 'Tramo: '}
              {activeTier.porcentaje}%
            </span>
          </span>
        )}
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={displayPrice}
          initial={{ opacity: 0, y: 3 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -3 }}
          transition={{ duration: 0.2 }}
        >
          <p className="text-xl xs:text-2xl md:text-xl lg:text-2xl xl:text-3xl font-black tracking-tight text-[#00234F] leading-tight break-all uppercase font-mono">
            {formatCurrency(displayPrice)}
          </p>
          <p className="text-[10px] font-bold text-slate-500 mt-1 truncate">
            {activeTier?.descripcion || (isInitial ? 'Precio de lista inicial' : '')}
            {hasTierScenario && (
              <span className="ml-1 text-slate-400 font-normal">
                (Lista inicial: {formatCurrency(basePrice)})
              </span>
            )}
          </p>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};
